import { Box, FormLabel, Typography, Skeleton } from "@mui/material";
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import TooltipFine from "../../new/paymentConditions/TooltipFine";
import TooltipInterest from "../../new/paymentConditions/TooltipInterest";
import InstallmentsTable from "./InvoiceShowPaymentConditions/InstallmentsTable";
import { formatCurrency } from "../../../helpers/financialHelpers";
import TooltipPaymentType from "./InvoiceShowPaymentConditions/TooltipPaymentType";

const InvoiceShowPaymentConditions = ({ invoice, setLoadingInstallmentsTable, loadingInstallmentsTable }) => {
    const WithSkeleton = ({ loading, children }) =>
        loading ? <Skeleton variant="text" width={80} /> : children;

    const paymentTypeMap = {
        other: 'Outro',
        credit_card: 'Cartão de crédito',
        debit_card: 'Cartão de débito',
        pix: 'PIX',
        boleto: 'Boleto bancário',
        cash: 'Dinheiro',
        check: 'Cheque',
        bank_deposit: 'Depósito bancário',
        bank_transfer: 'Transferência bancária',
    };

    const invoicePerformedDate = invoice?.performed_date
        ? new Date(invoice.performed_date).toLocaleDateString('pt-BR')
        : '-';
    const invoicePaymentType = invoice?.payment_type || '';
    const invoiceDiscount = invoice?.discount || '';
    const invoiceInterest = invoice?.interest || '-';
    const invoiceFine = invoice?.fine || '-';
    const installmentCount = invoice?.installments?.length || 0;
    const invoiceIntegrated = invoice?.integrated === true ? "Automático (Produttivo)" : invoice?.integrated === false ? "Manual (Outros bancos)" : "-";

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CreditCardRoundedIcon sx={{ color: 'primary.main' }} />
                    <Typography variant='h5' sx={{ color: 'primary.main' }}> Condições de pagamento</Typography>
                </Box>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                        gap: 2,
                    }}
                >
                    <Box>
                        <FormLabel sx={{ color: 'text.primary' }}><b>Data de competência</b></FormLabel>
                        <WithSkeleton loading={!invoice}>
                            <Typography>{invoicePerformedDate}</Typography>
                        </WithSkeleton>
                    </Box>

                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <FormLabel sx={{ color: 'text.primary' }}><b>Forma de pagamento</b></FormLabel>
                            <TooltipPaymentType />
                        </Box>
                        <WithSkeleton loading={!invoice}>
                            <Typography>{invoiceIntegrated}</Typography>
                        </WithSkeleton>
                        <WithSkeleton loading={!invoice}>
                            <Typography>{paymentTypeMap[invoicePaymentType]}</Typography>
                        </WithSkeleton>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                        gap: 2,
                    }}
                >
                    <Box>
                        <FormLabel sx={{ color: 'text.primary' }}><b>Desconto</b></FormLabel>
                        <WithSkeleton loading={!invoice}>
                            <Typography>R$ {formatCurrency(invoiceDiscount)}</Typography>
                        </WithSkeleton>
                    </Box>

                    <Box>
                        <TooltipInterest />
                        <WithSkeleton loading={!invoice}>
                            <Typography>{invoiceInterest}</Typography>
                        </WithSkeleton>
                    </Box>

                    <Box>
                        <TooltipFine />
                        <WithSkeleton loading={!invoice}>
                            <Typography>{formatCurrency(invoiceFine)}</Typography>
                        </WithSkeleton>
                    </Box>
                </Box>
            </Box>
            {installmentCount && (
                <InstallmentsTable invoice={invoice} setLoadingInstallmentsTable={setLoadingInstallmentsTable} loadingInstallmentsTable={loadingInstallmentsTable} />
            )}
        </>
    )
}

export default InvoiceShowPaymentConditions;